<ng-content select="[app-dropdown-trigger]"></ng-content>

<ng-template app-dropdown-host><ng-content></ng-content></ng-template>
